export const radius = {
  none: '0px',
  sm: '4px',
  md: '8px',
  lg: '16px',
  pill: '9999px',
}
